/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type AgentUpdatedEvent = {
  agent: Address;
  owner: Address;
  timestamp: bigint;
};

export type AgentUpdatedEventArgs = {
  agent: Address;
  owner: Address;
  timestamp: number | bigint;
};

export function getAgentUpdatedEventEncoder(): FixedSizeEncoder<AgentUpdatedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getAgentUpdatedEventDecoder(): FixedSizeDecoder<AgentUpdatedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getAgentUpdatedEventCodec(): FixedSizeCodec<
  AgentUpdatedEventArgs,
  AgentUpdatedEvent
> {
  return combineCodec(
    getAgentUpdatedEventEncoder(),
    getAgentUpdatedEventDecoder(),
  );
}
